module.exports = __webpack_public_path__ + "static/media/photo207.4b1f272c.jpg";